export default __webpack_public_path__ + "static/media/arrow-right.a66ad580.svg";